document.querySelectorAll( '.woocommerce-form-register, .woocommerce-ResetPassword' ).forEach( form => {
	form.querySelectorAll( 'input, select, textarea' ).forEach( field => {
		field.addEventListener( 'focus', () => {
			if( 'true' !== form.dataset.whippetHpFieldSet ) {
				form.insertAdjacentHTML( 'beforeend', `<div style="display: none;"><label for="whippet-hp">Leave this field blank.</label><input type="hidden" name="whippet-hp" id="whippet-hp" value=""></div>` );
				form.dataset.whippetHpFieldSet = 'true';
			}
		} );
	} );
} );
